export const getExtentUnits = () => {
    const extentUnits = [
        {
            id: 'Sq.Ft',
            name: 'Sq.Ft'
        },
        {
            id: 'Sq.Yards',
            name: 'Sq.Yards'
        },
        {
            id: 'Sq.Meter',
            name: 'Sq.Meter'
        },
        {
            id: 'Sq.Lings',
            name: 'Sq.Lings'
        },
        {
            id: 'Acres',
            name: 'Acres'
        },
        {
            id: 'Cents',
            name: 'Cents'
        },
        {
            id: 'Hectares',
            name: 'Hectares'
        },
        {
            id: 'Ground',
            name: 'Ground'
        },
        {
            id: 'Kuzhi',
            name: 'Kuzhi'
        },
        {
            id: 'Kaani',
            name: 'Kaani'
        },
        {
            id: 'Ares',
            name: 'Ares'
        },
        {
            id: 'Veesam',
            name: 'Veesam'
        },
        {
            id: 'Santhiyar',
            name: 'Santhiyar'
        },
        {
            id: 'Kejam',
            name: 'Kejam'
        },
    ]
    return extentUnits;
};

export const getCustomUnits = () => {
    const customUnits = [
        {
            id: 'Lings',
            name: 'Ling'
        },
        {
            id: 'Yards',
            name: 'Yards'
        },
        {
            id: 'ft',
            name: 'ft'
        },
        {
            id: 'mt',
            name: 'mt'
        },
        {
            id: 'Ankanam',
            name: 'Ankanam'
        },
        {
            id: 'Kejam',
            name: 'Kejam'
        },
    ];
    return customUnits;
};

export const getNatureDocs = () => {
    const nature_docs = [
        {
            id: '',
            name: 'Select the Nature of property'
        },
        {
            id: 'Agri',
            name: 'Agri'
        },
        {
            id: 'Existing building',
            name: 'Existing building'
        },
        {
            id: 'Under construction',
            name: 'Under construction'
        },
        {
            id: 'vacant land',
            name: 'Vacant Land'
        },
        {
            id: 'appartment',
            name: 'Appartment'
        }
    ]
    return nature_docs;
};